  <template>
    <!-- <div :style="outerDivStyle"> -->
    <div class="container-fluid p-0" style="background-image: url('/23299312_m.jpg'); background-size: cover; background-position: center; min-height: 100vh;">
      <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="../assets/李二萌.jpg" class="d-block w-100" style="object-fit: contain; max-height: 450px;" alt="...">
            <div class="carousel-caption d-none d-md-block">
              <h1>李二萌</h1>
              <p>年轻人就该出去溜达溜达</p>
            </div>
          </div>
          <div class="carousel-item">
            <img src="../assets/在加納共和國離婚.jpg" class="d-block w-100" style="object-fit: contain; max-height: 450px;" alt="...">
            <div class="carousel-caption d-none d-md-block">
              <h5>在加納共和國離婚</h5>
              <p>...</p>
            </div>
          </div>
          <div class="carousel-item">
            <img src="../assets/JiaJia家家.jpg" class="d-block w-100" style="object-fit: contain; max-height: 450px;" alt="...">
            <div class="carousel-caption d-none d-md-block">
              <h5>JiaJia家家 [ 家家酒Playhouse ]</h5>
              <p>Some representative placeholder content for the third slide.</p>
            </div>
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'carousel',
    data() {
      return {
        outerDivStyle: {
          backgroundImage: "url('../assets/IMG20240901084507.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '20px'
        }
      };
    }
  }
  </script>
  